import { render, staticRenderFns } from "./createCaixa.vue?vue&type=template&id=2182cb88&scoped=true&"
import script from "./createCaixa.vue?vue&type=script&lang=js&"
export * from "./createCaixa.vue?vue&type=script&lang=js&"
import style0 from "./createCaixa.vue?vue&type=style&index=0&id=2182cb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2182cb88",
  null
  
)

export default component.exports